module.exports = __webpack_public_path__ + "static/media/sso-guest-login-indication.33332e78.png";